import { createIcon } from '@chakra-ui/react'

export const ChecksIcon = createIcon({
  displayName: 'ChecksIcon',
  viewBox: '0 0 24 24',
  d: 'M14.405 8.405l-8.25 8.25a.75.75 0 01-1.06 0L.97 12.53a.75.75 0 011.06-1.06l3.595 3.594 7.72-7.72a.75.75 0 011.06 1.061zm8.625-1.06a.75.75 0 00-1.06 0l-7.72 7.72-1.661-1.662a.75.75 0 00-1.06 1.061l2.19 2.191a.75.75 0 001.061 0l8.25-8.25a.75.75 0 000-1.06z',
})
